import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ArrowLeft, Share2, ChevronLeft, ChevronRight, MapPin, Calendar } from 'lucide-react';
import { getShareLink } from '../utils/links';

const ATTENDED_BURIALS = [
  { id: 'ab-1', name: 'Zainab binti Ahmad',       date: '02 Apr 2026, 1:00 PM',  location: 'Pusara Aman, Blk 16, Plot 21'  },
  { id: 'ab-2', name: 'Ismail bin Tariq',          date: '15 Feb 2026, 10:45 AM', location: 'Pusara Aman, Blk 15, Plot 305' },
  { id: 'ab-3', name: 'Halimah binti Kassim',      date: '20 Dec 2025, 3:30 PM',  location: 'Pusara Aman, Blk 14, Plot 99'  },
  { id: 'ab-4', name: 'Omar bin Farid',            date: '08 Sep 2025, 11:00 AM', location: 'Pusara Aman, Blk 14, Plot 12'  },
  { id: 'ab-5', name: 'Nurul Aini binti Saleh',    date: '12 May 2025, 4:00 PM',  location: 'Pusara Aman, Blk 13, Plot 150' }
];

export default function MyAttendedBurials({ onBack }) {
  const handleShare = (entry) => {
    const slug = entry.name.toLowerCase().replace(/\s+/g, '-');
    const link = getShareLink('casket-attended', { slug });
    const text = encodeURIComponent(
      `Assalamualaikum,\n\nIn remembrance of the late ${entry.name} — laid to rest on ${entry.date} at ${entry.location}.\n\nView the completed service tracker here:\n${link}\n\nAl-Fatihah.`
    );
    window.open(`https://wa.me/?text=${text}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen bg-muted/20">
      <header className="bg-card border-b sticky top-0 z-10 shadow-sm">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Button variant="ghost" onClick={onBack} className="gap-2" data-testid="attended-burials-back">
            <ArrowLeft className="h-4 w-4" />
            Back
          </Button>
          <h1 className="text-lg sm:text-xl font-semibold">My Attended Burials</h1>
          <div className="w-16" />
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-6 space-y-4">
        {ATTENDED_BURIALS.map((entry) => (
          <Card key={entry.id} data-testid={`attended-burial-${entry.id}`} className="border">
            <CardContent className="p-4 sm:p-5">
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-base sm:text-lg leading-tight">
                    {entry.name}
                  </h3>
                  <p className="text-sm text-muted-foreground mt-1.5 flex items-center gap-1.5">
                    <Calendar className="h-3.5 w-3.5 flex-shrink-0" />
                    {entry.date}
                  </p>
                  <p className="text-sm text-muted-foreground mt-1 flex items-start gap-1.5">
                    <MapPin className="h-3.5 w-3.5 flex-shrink-0 mt-0.5" />
                    <span>{entry.location}</span>
                  </p>
                </div>
                <button
                  data-testid={`share-${entry.id}`}
                  onClick={() => handleShare(entry)}
                  aria-label="Share tracker link"
                  className="w-9 h-9 rounded-full border hover:bg-primary/5 hover:border-primary transition-colors flex items-center justify-center flex-shrink-0"
                >
                  <Share2 className="h-4 w-4 text-primary" />
                </button>
              </div>
            </CardContent>
          </Card>
        ))}

        {/* Pagination (dummy) */}
        <nav
          data-testid="attended-burials-pagination"
          className="flex items-center justify-center gap-1 pt-4 pb-6 text-sm"
        >
          <button className="px-2 py-1.5 rounded-md hover:bg-muted flex items-center gap-1 text-muted-foreground">
            <ChevronLeft className="h-4 w-4" />
            Prev
          </button>
          {[1, 2, 3, 4].map((n) => (
            <button
              key={n}
              className={`w-8 h-8 rounded-md ${n === 1 ? 'bg-primary text-primary-foreground font-semibold' : 'hover:bg-muted text-foreground'}`}
            >
              {n}
            </button>
          ))}
          <button className="px-2 py-1.5 rounded-md hover:bg-muted flex items-center gap-1 text-muted-foreground">
            Next
            <ChevronRight className="h-4 w-4" />
          </button>
        </nav>
      </div>
    </div>
  );
}
